// from general.js
/* global trim dcAnalytics jQuery */

import { removeHTMLTagsAndIEStyleNewLines, getTooLongMessage } from '../utils/stringUtils.ts';

function countWords(text) {
    if (!text) {
        return 0;
    }
    const textArray = trim(text).split(/\s+/);
    return textArray.length;
}

function countLines(text) {
    if (!text) {
        return 0;
    }
    const textArray = text.split(/\n/);
    return textArray.length;
}

function setWordCheckState(container, edge, limit, state) {
    const selector = container + ' ~ #wordcount-';
    if (state === 'neutral') {
        $(selector + edge + ' span').html(limit + ' words ' + edge).css({ color: '#000000' });
        $(selector + edge + ' .icon').css('opacity', '0');
    } else {
        $(selector + edge + ' span').html('<b>' + limit + ' words ' + edge + '</b>').css('font-style', 'normal');
        $(selector + edge + ' .icon').css('opacity', '1');
        if (state === 'long') {
            $(selector + edge + ' span').css('color', '#CD2929');
            $(selector + 'max').css('display', 'inline');
            $(selector + 'min').css('display', 'none');
        } else {
            $(selector + edge + ' span').css('color', '#01695E');
            $(selector + 'max').css('display', 'none');
            $(selector + 'min').css('display', 'inline');
        }
    }
}

/**
 *  contenteditable is difficult to work with, so use a normal textarea if possible
 *
 *  use data fields to set some variables:
 *  data-min (required)
 *  data-max (required)
 */
export function checkWordCount(el, minWords, maxWords, maxLines) {
    let i;
    let trimmedElText;
    let elTextArray;
    let maxCharacters;
    const isContentEditable = $(el).attr('contenteditable') && ($(el).attr('contenteditable') != 'false');
    let elText = (isContentEditable) ? $(el).html() : $(el).val();
    // in IE, new lines are represented by \r\n
    elText = removeHTMLTagsAndIEStyleNewLines(elText);
    const elWordCount = countWords(elText);
    const elLineCount = countLines(elText);
    maxWords = maxWords || $(el).data('max');
    minWords = minWords || $(el).data('min');
    let progressBarLength = 0;
    // maxLines is optional. If its not included we will check its check
    maxLines = maxLines || $(el).data('max-lines');
    const parentContainer = '#' + el.id + '-remaining';
    $('#' + el.id).removeClass('minReached').removeClass('maxExceeded').removeClass('minNotReached');

    // to capture all the non TPC textareas that have max line count
    if (maxLines) {
        if (elWordCount > maxWords) {
            $('#' + el.id).addClass('maxExceeded');
            maxCharacters = elText.length;
            elTextArray = trim(elText).split(/\s+/);
            trimmedElText = elText;
            for (i = 0; i < maxWords; i++) {
                trimmedElText = trimmedElText.replace(elTextArray[i], '');
            }
            maxCharacters = elText.lastIndexOf(trim(trimmedElText));
            if (isContentEditable) {
                $('#' + el.id).html(elText.substring(0, maxCharacters) + '<span class="highlight-error">' + elText.substring(maxCharacters) + '</strong>');
                $('#' + el.id + ' .highlight-error').selectText();
            } else {
                el.setSelectionRange(maxCharacters, elText.length);
            }
            $('#' + el.id + '-remaining').html(getTooLongMessage(maxWords, 'word'));
            dcAnalytics.trackEventGA([pageName, 'Max character limit reached', el.name]);
            return false;
        } else if (elLineCount > maxLines) {
            $('#' + el.id).addClass('maxExceeded');
            maxCharacters = elText.length;
            elTextArray = trim(elText).split(/\n+/);
            trimmedElText = elText;
            for (i = 0; i < maxLines; i++) {
                trimmedElText = trimmedElText.replace(elTextArray[i], '');
            }
            maxCharacters = elText.lastIndexOf(trim(trimmedElText));
            if (isContentEditable) {
                $('#' + el.id).html(elText.substring(0, maxCharacters) + '<span class="highlight-error">' + elText.substring(maxCharacters) + '</strong>');
                $('#' + el.id + ' .highlight-error').selectText();
            } else {
                el.setSelectionRange(maxCharacters, elText.length);
            }
            $('#' + el.id + '-remaining').html(getTooLongMessage(maxLines, 'line'));
            dcAnalytics.trackEventGA([pageName, 'Max line limit reached', el.name]);
            return false;
        } else if (elWordCount >= minWords) {
            $('#' + el.id).addClass('minReached');
            $('#' + el.id + '-remaining').html("<span class='min-reached'>Great job, you've written enough!</span>");
            return true;
        } else if (elWordCount > 0 && elWordCount < minWords) {
            const wordsToGo = minWords - elWordCount;
            $('#' + el.id + '-remaining').html('<span>' + wordsToGo + ' words left</span>');
            return false;
        }
        return false;
    } else {
        if (elWordCount > maxWords) {
            $(parentContainer + ' .word-count').html("<span class='min-reached'>" + elWordCount + ' words</span>');
            $(parentContainer + ' .filler').css({ width: '100%', 'background-color': '#CD2929' });

            setWordCheckState(parentContainer, 'max', maxWords, 'long');
            setWordCheckState(parentContainer, 'min', minWords, 'neutral');

            $('.disableIfTooLong').addClass('disabled');
            dcAnalytics.trackEventGA([pageName, 'Max character limit reached', el.name]);
            return false;
        } else if (elWordCount >= minWords) {
            $(parentContainer + ' .word-count').html("<span class='min-reached'>" + elWordCount + ' words</span>');
            $(parentContainer + ' .filler').css({ width: '100%', 'background-color': '#01695E' });

            setWordCheckState(parentContainer, 'max', maxWords, 'neutral');
            setWordCheckState(parentContainer, 'min', minWords, 'minsurpassed');

            $('.disableIfTooLong').removeClass('disabled');
            return true;
        } else if (elWordCount > 0 && elWordCount < minWords) {
            progressBarLength = elWordCount / minWords * 100;
            $(parentContainer + ' .word-count').html('<span>' + elWordCount + ' words</span>');
            $(parentContainer + ' .filler').css({ width: progressBarLength + '%', 'background-color': '#3DA9F3' });

            setWordCheckState(parentContainer, 'max', maxWords, 'neutral');
            setWordCheckState(parentContainer, 'min', minWords, 'neutral');

            $('.disableIfTooLong').removeClass('disabled');
            return false;
        } else {
            $(parentContainer + ' .filler').css('width', '0');
            $(parentContainer + ' .word-count').html('<span>' + elWordCount + ' words</span>');
            setWordCheckState(parentContainer, 'max', maxWords, 'neutral');
            setWordCheckState(parentContainer, 'min', minWords, 'neutral');
            $('.disableIfTooLong').removeClass('disabled');
            return false;
        }
    }
}

export function validateMinCharacterCount(el, minChar) {
    minChar = minChar || $(el).data('min');
    if (!minChar) {
        return true;
    }
    let elText = $(el).val();
    elText = removeHTMLTagsAndIEStyleNewLines(elText);
    return elText.length >= minChar;
}

export function validateMinWordCount(el, minWords) {
    minWords = minWords || $(el).data('min');
    if (!minWords) {
        return true;
    }
    let elText = $(el).val();
    elText = removeHTMLTagsAndIEStyleNewLines(elText);
    return countWords(elText) >= minWords;
}

export function validateMaxCharacterCount(el, maxChar) {
    maxChar = maxChar || $(el).data('max');
    if (!maxChar) {
        return true;
    }
    let elText = $(el).val();
    elText = removeHTMLTagsAndIEStyleNewLines(elText);
    return elText.length <= maxChar;
}

export function validateMaxWordCount(el, maxWords) {
    maxWords = maxWords || $(el).data('max');
    if (!maxWords) {
        return true;
    }
    let elText = $(el).val();
    elText = removeHTMLTagsAndIEStyleNewLines(elText);
    return countWords(elText) <= maxWords;
}

// from http://stackoverflow.com/questions/6139107/programatically-select-text-in-a-contenteditable-html-element
jQuery.fn.selectText = function () {
    let range, selection;
    return this.each(function () {
        if (document.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(this);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(this);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    });
};
